var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefault6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1456_169116)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "ext5_2",
    x: 0.363281,
    width: 40,
    height: 40,
    rx: 20
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "ext1_1",
    x: 23.6973,
    y: -16.1999,
    width: 16.6667,
    height: 63.0291
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "ext4_1",
    x: 48.2598,
    y: 5.44659,
    width: 62.5,
    height: 1.66667,
    transform: "rotate(150 48.2598 5.44659)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "ext4_1",
    x: 49.9258,
    y: 8.33331,
    width: 62.5,
    height: 1.66667,
    transform: "rotate(150 49.9258 8.33331)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "ext4_1",
    x: 51.5938,
    y: 11.2201,
    width: 62.5,
    height: 1.66667,
    transform: "rotate(150 51.5938 11.2201)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "ext4_1",
    x: 53.2598,
    y: 14.1068,
    width: 62.5,
    height: 1.66667,
    transform: "rotate(150 53.2598 14.1068)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1456_169116"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.363281,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault6);
export default __webpack_public_path__ + "static/media/Default6.f95dfebe.svg";
export { ForwardRef as ReactComponent };